import { IApiClientThemeResponse } from "@hooks/api/theme";

export const mapClientThemeSettings = (
  data: IApiClientThemeResponse,
): ClientSettingsWithKeys => {
  return {
    name: data.digitacao.titulo,
    benefitCardName: data.digitacao.titulo_cartao,
    supportEmail: data.digitacao.email_de_suporte,
    theme: {
      token: {
        colorPrimary: data.digitacao.cor_primaria,
        colorHighlight: data.digitacao.cor_secundaria,
      },
    },
    assets: {
      background: data.digitacao.background ?? "",
      logo: data.digitacao.logo,
      favicon: data.digitacao.favicon,
      card: data.digitacao.imagem_do_cartao,
      consignedCard: data.digitacao.imagem_cartao_consignado,
    },
    apiKeys: {
      newRelic: {
        applicationId: data.digitacao.api_keys.new_relic_application_id,
        accountId: data.digitacao.api_keys.new_relic_account_id,
        licenceKey: data.digitacao.api_keys.new_relic_license_key,
      },
      smartlook: {
        clientKey: data.digitacao.api_keys.smartlook_client_key,
      },
      clarity: {
        clientKey: data.digitacao.api_keys.clarity_client_key,
      },
      dataDog: {
        applicationId: undefined,
        clientToken: undefined,
        serviceName: undefined,
      },
    },
    bannersList: data.banners,
  };
};
